import wx from 'weixin-js-sdk'
import { API } from '../api'
import { WEIXIN_BASE } from './base'

var WEIXIN_PAY = {
    createOrder(params, sucCb, failCb) {
        WEIXIN_BASE.getAuthorationAndConfigJsSDK(function() {
            wx.ready(function () { 
                wx.chooseWXPay({
                    timestamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                    nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                    package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                    paySign: params.paySign, // 支付签名
                    success: function (res) {
                        // 支付成功后的回调函数
                        console.log('支付成功:::::::::', res);
                        if(sucCb && typeof(sucCb) == 'function') {
                            sucCb();
                        }
                    },
                    fail: function (res) {
                        console.log('支付失败::::::::', res);
                        if(failCb && typeof(failCb) == 'function') {
                            failCb();
                        }
                    },
                    cancel: function (res) {
                        console.log('支付取消::::::::', res);
                        if(failCb && typeof(failCb) == 'function') {
                            failCb();
                        }
                    }
                })
            })
        })
    },
    createBridgeOrder(params, sucCb) {
        function onBridgeReady(){
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                    "appId": params.appId,              //公众号名称，由商户传入     
                    "timeStamp": params.timeStamp,           //时间戳，自1970年以来的秒数     
                    "nonceStr": params.nonceStr, //随机串     
                    "package": params.package,     
                    "signType": params.signType,         //微信签名方式：     
                    "paySign": params.paySign //微信签名 
                },
                function(res){
                    if(res.err_msg == "get_brand_wcpay_request:ok" ){
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        // 支付成功后的回调函数
                        console.log('支付成功:::::::::', res);
                        if(sucCb && typeof(sucCb) == 'function') {
                            sucCb();
                        }
                    } 
                }); 
         }
        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        }else{
            onBridgeReady();
        }
    }
}

export {
    WEIXIN_PAY
}